import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { IStateType } from '../../../../../store/models/root.interface';

import {
	closeSideBar,
	getParams,
} from '../../../../../store/sidebar';
import EditCredentialModal, { MapDispatchToPropsType, MapStateToPropsType } from '../EditCredentialModal';
import {updateObjects} from "../../../../../store/Objects";
import {InstanceAPIs, Instances} from "../../../../../constants";
import {makeSelectInProgress, makeSelectObject, removeObject, requestObject} from "../../../../../store/Object";

const mapStateToProps = (state: IStateType) => {
	const params = getParams(state);
	const selectBridgeNumbers = makeSelectObject(Instances.BridgeNumbers);
	const selectBridgeNumberInProgress = makeSelectInProgress(Instances.BridgeNumbers);
	return (state: IStateType) => ({
		params,
		bridgeNumbers: selectBridgeNumbers(state),
		bridgeNumberInProgress: selectBridgeNumberInProgress(state)
	});
};
const mapDispatchToProps = {
	onClose: () => closeSideBar([removeObject(Instances.BridgeNumbers)]),
	getBridgeNumbers: (params:any) => requestObject(Instances.BridgeNumbers,params),
	editCredential: (reqData: any,filters:any,keyForIdentifier:string,dynamicUrlData:string, cb?: (res: any, success: boolean)=> void) =>  updateObjects(Instances.SipCredential, "PUT", reqData, filters, undefined, keyForIdentifier, undefined, undefined, cb, dynamicUrlData, InstanceAPIs[Instances.SipCredential].PUT),
};

export default connect<
	MapStateToPropsType,
	MapDispatchToPropsType,
	unknown,
	IStateType
>(
	mapStateToProps,
	mapDispatchToProps
)(withImmutablePropsToJS(EditCredentialModal));
